import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './Routes/routes';
import Header from './Components/Header/Header.js'
import Footer from './Components/Footer/Footer.js';

function App() {

  return (
    <div className='App'>


      <Header />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Footer />
    </div>
  );
}
export default App;
